export function sleep(ms: number, value: unknown) {
  return new Promise(resolve => setTimeout(() => resolve(value), ms));
}
